import Keycloak, { KeycloakInstance } from "keycloak-js";

const keycloakConfig: any = {
  url: process.env.REACT_APP_KC_BASE, 
  realm: process.env.REACT_APP_KC_REALM, 
  clientId: process.env.REACT_APP_KC_CLIENT_ID, 
};

let keycloak: any;

export async function initKeycloak(): Promise<KeycloakInstance> {
  keycloak = new (Keycloak as any)(keycloakConfig);

  const authenticated = await keycloak.init({
    onLoad: "login-required",
    checkLoginIframe: false,
    pkceMethod: "S256",
    enableLogging: true,
  });

  if (!authenticated) {
    throw new Error("Unable to authenticate with Keycloak");
  }

  return keycloak;
}
export function getKeycloak(): KeycloakInstance {
  if (!keycloak) {
    throw new Error('Keycloak has not been initialized yet');
  }
  return keycloak;
}